module.exports = __webpack_public_path__ + "static/media/Asset 1@4x.37a15200.png";